import { createFileRoute } from '@tanstack/react-router';
import { getAuthtoken, getSelectedOrganizationId } from 'stores/useAuthStore';
import LocationManagement from 'containers/LocationManagement';
import { locationsQueryOptions } from 'containers/LocationManagement/useLocationManagement';

export const Route = createFileRoute('/_authenticated/locationManagement')({
  loader: ({ context }) => {
    const authToken = getAuthtoken();
    const organizationId = getSelectedOrganizationId();
    return context.queryClient.prefetchQuery(
      locationsQueryOptions(authToken, organizationId)
    );
  },
  component: LocationManagement,
});
